import type { SVGProps } from 'react';
const SvgNavServices = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height={24}
    fill="none"
    width={24}
    {...props}
  >
    <path
      d="M4 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 19V8q0-.824.587-1.412A1.93 1.93 0 0 1 4 6h4V4q0-.824.588-1.412A1.93 1.93 0 0 1 10 2h4q.825 0 1.412.587Q16 3.176 16 4v2h4q.824 0 1.413.588Q22 7.175 22 8v11q0 .824-.587 1.413A1.93 1.93 0 0 1 20 21zm6-15h4V4h-4zm10 9h-5v1q0 .424-.287.712A.97.97 0 0 1 14 17h-4a.97.97 0 0 1-.713-.288A.97.97 0 0 1 9 16v-1H4v4h16zm-9 0h2v-2h-2zm-7-2h5v-1q0-.424.287-.713A.97.97 0 0 1 10 11h4q.424 0 .713.287.287.288.287.713v1h5V8H4z"
      fill="currentColor"
    />
  </svg>
);
export default SvgNavServices;
